import { useWizardStore, type NeutralAnswer } from '../store/wizardStore';
import { InfoHint } from './InfoHint';

// P0-2 — explicit, always-visible neutral question (not a hover tooltip).
// Persists to the wizard store so it can filter incompatible tech and flow into
// the quote. Shown inline in the tech step of both device wizards.
const OPTIONS: { value: NeutralAnswer; label: string }[] = [
  { value: 'yes', label: 'Sim' },
  { value: 'no', label: 'Não' },
  { value: 'unknown', label: 'Não sei' },
];

export function NeutralQuestion() {
  const hasNeutral = useWizardStore((s) => s.hasNeutral);
  const setHasNeutral = useWizardStore((s) => s.setHasNeutral);
  return (
    <div className="mb-3 rounded-smartify border border-smartify-line bg-smartify-paper p-3">
      <p className="text-xs font-semibold text-smartify-ink">Tens neutro nas caixas?</p>
      <div className="mt-2 flex gap-2">
        {OPTIONS.map((o) => (
          <button
            key={o.value}
            type="button"
            onClick={() => setHasNeutral(o.value)}
            aria-pressed={hasNeutral === o.value}
            className={[
              'flex-1 rounded-smartify border px-3 py-1.5 text-sm font-medium transition-colors',
              hasNeutral === o.value
                ? 'border-smartify-brand bg-smartify-brand text-white'
                : 'border-smartify-line bg-white text-smartify-ink hover:border-smartify-brand/50',
            ].join(' ')}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div className="mt-2">
        <InfoHint label="O que é o neutro?">
          O neutro é um fio (normalmente azul) na caixa por trás do interruptor. Muitos módulos
          inteligentes precisam dele; outros (Zigbee «sem neutro») não. Se não souberes, escolhe
          «Não sei» — assumimos a opção sem neutro e confirmamos na visita técnica.
        </InfoHint>
      </div>
      {hasNeutral === 'unknown' && (
        <p className="mt-2 text-[11px] text-amber-700">
          Sem problema — vamos assumir a solução que dispensa neutro e confirmamos no local.
        </p>
      )}
    </div>
  );
}
